module.exports = __webpack_public_path__ + "img/image_home_bottom.7abe8724.png";